import { createUseStyles } from 'react-jss';
import { Theme } from '../themes/default';

const useBattleStyles = createUseStyles((theme: Theme) => {
    return {
        wrapper: {
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '24px 20px',
            border: `5px dotted ${theme.colors.espresso_brown}`,
            margin: '0 auto',
            marginTop: theme.spacing(4),
            borderRadius: '10px',
            maxWidth: '1000px',
            overflowX: 'hidden',        // fix scroll lateral pe mobile
            [theme.breakpoints.up('sm')]: {
                padding: '32px 60px',
            },
            [theme.breakpoints.up('md')]: {
                padding: '48px 80px',
            },
        },
        content: {
            position: 'relative',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
        },
        logoBattle: {
            width: '160px',
            height: 'auto',
            marginBottom: theme.spacing(1),
            [theme.breakpoints.up('sm')]: {
                width: '200px',
            },
            [theme.breakpoints.up('md')]: {
                width: '240px',
            },
        },
        subtitle: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.espresso_brown,
            fontSize: '0.95rem',
            textAlign: 'center',
            marginBottom: theme.spacing(3),
            maxWidth: '420px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '1.05rem',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '1.1rem',
            },
        },

        /* ---- LAYOUT PRINCIPAL ---- */
        mainLayout: {
            position: 'relative',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginTop: theme.spacing(2),
        },

        /* ---- RAND TEXTE ---- */
        labelsRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            marginBottom: theme.spacing(1),
        },

        /* ---- RAND STICLE ---- */
        bottlesRow: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'center',
            width: '100%',
            zIndex: 2,
            marginBottom: theme.spacing(-1),
        },
        bottlesMiddleSpacer: {
            flexShrink: 0,
            width: '80px',
            [theme.breakpoints.up('sm')]: {
                width: '140px',
            },
            [theme.breakpoints.up('md')]: {
                width: '220px',
            },
        },
        /* ---- GRUP: text + sticla ---- */
        bottleGroup: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.spacing(1),
        },

        /* ---- TEAM LIGHT LABEL ---- */
        teamLightLabel: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: '1rem',
            fontWeight: 'bold',
            letterSpacing: '2px',
            textAlign: 'center',
            transform: 'rotate(-6deg)',
            whiteSpace: 'nowrap',
            display: 'block',
            [theme.breakpoints.up('sm')]: {
                fontSize: '1.3rem',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '1.8rem',
            },
        },

        /* ---- TEAM DARK LABEL ---- */
        teamDarkLabel: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: '1rem',
            fontWeight: 'bold',
            letterSpacing: '2px',
            textAlign: 'center',
            transform: 'rotate(-6deg)',
            whiteSpace: 'nowrap',
            display: 'block',
            [theme.breakpoints.up('sm')]: {
                fontSize: '1.3rem',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '1.8rem',
            },
        },

        teamLabel: {
            fontFamily: theme.fonts.apex,
            color: theme.colors.latte_cream,
            fontSize: '1rem',
            fontWeight: 'bold',
            letterSpacing: '2px',
            textAlign: 'center',
            transform: 'rotate(-6deg)',
            whiteSpace: 'nowrap',
            width: '90px',
            [theme.breakpoints.up('sm')]: {
                fontSize: '1.3rem',
                width: '120px',
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '1.8rem',
                width: '160px',
            },
        },

        /* ---- STICLA BLONDA ---- */
        bottleBlondaWrapper: {
            border: `4px solid ${theme.colors.latte_cream}`,
            borderRadius: '0px',
            padding: theme.spacing(3),
            transform: 'rotate(-6deg)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'transparent',
            width: '90px',
            boxSizing: 'border-box' as const,
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(4),
                width: '120px',
            },
            [theme.breakpoints.up('md')]: {
                padding: theme.spacing(5),
                width: '160px',
            },
        },

        /* ---- STICLA BRUNA ---- */
        bottleBrunaWrapper: {
            border: `4px solid ${theme.colors.latte_cream}`,
            borderRadius: '0px',
            padding: theme.spacing(3),
            transform: 'rotate(-6deg)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme.colors.latte_cream,
            width: '90px',
            boxSizing: 'border-box' as const,
            [theme.breakpoints.up('sm')]: {
                padding: theme.spacing(4),
                width: '120px',
            },
            [theme.breakpoints.up('md')]: {
                padding: theme.spacing(5),
                width: '160px',
            },
        },

        bottleImage: {
            width: '40px',
            height: 'auto',
            transform: 'rotate(6deg)',
            display: 'block',
            [theme.breakpoints.up('sm')]: {
                width: '55px',
            },
            [theme.breakpoints.up('md')]: {
                width: '80px',
            },
        },

        /* ---- VS IMAGE ---- */
        lightVsDarkImage: {
            width: '300px',
            height: 'auto',
            position: 'relative',
            zIndex: 1,
            [theme.breakpoints.up('sm')]: {
                width: '360px',
            },
            [theme.breakpoints.up('md')]: {
                width: '700px',
            },
        },

         /* ---- START BUTTON ---- */
        startButton: {
            marginTop: theme.spacing(4),
            padding: `${theme.spacing(1.5)}px ${theme.spacing(5)}px`,
            backgroundColor: theme.colors.espresso_brown,
            color: theme.colors.latte_cream,
            fontFamily: theme.fonts.poplar,
            fontSize: '1.2rem',
            letterSpacing: '3px',
            border: `2px solid ${theme.colors.espresso_brown}`,
            cursor: 'pointer',
            borderRadius: '4px',
            transition: 'all 0.2s ease',
            '&:hover': {
                backgroundColor: theme.colors.latte_cream,
                color: theme.colors.espresso_brown,
            },
            [theme.breakpoints.up('sm')]: {
                fontSize: '1.4rem',
                padding: `${theme.spacing(2)}px ${theme.spacing(6)}px`,
            },
            [theme.breakpoints.up('md')]: {
                fontSize: '1.6rem',
                padding: `${theme.spacing(2)}px ${theme.spacing(8)}px`,
            },
        },
    };
});

export default useBattleStyles;